import React from 'react';
import {AisinoFormItem, AisinoRadioButton} from "../../../baseComponent/form";
import AisinoInput from "../../../baseComponent/form/input/AisinoInput";

const formItemTailLayout = {wrapperCol: {offset: 1, span: 13},};

class FormItemInputGroup extends React.Component {

    render() {
        return(
            <AisinoFormItem {...formItemTailLayout} label={this.props.label}>
                <AisinoFormItem noStyle={true} {...this.props} onChange={this.props.onChangeItem}>
                    <AisinoInput style={{ width: '60%' }} disabled={this.props.input_disabled} onChange={this.props.onChange}/>
                </AisinoFormItem>
                <AisinoRadioButton style={{ textAlign:'center',width: '40%',color: '#1890ff',}} {...this.props}>{this.props.buttontext}</AisinoRadioButton>
            </AisinoFormItem>
        );
    }
}

export default FormItemInputGroup;